{
  "header": {
    "title": "Frågeschema",
    "description": "Granska och analysera tidigare återkopplingssvar"
  },
  "categorySection": {
    "title": "Kategorifördelning"
  }
}
